
define(
	'Tavano.TT_HideAddToQuote.HideAddToQuote'
,   [
	
	]
,   function (

	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var layout = container.getComponent('Layout');
			var pdp = container.getComponent('PDP');

			if (layout) {
				if (pdp) {
					layout.addToViewContextDefinition("ProductDetailToQuote.View", "isQuotable", "boolean", function (context) {
						return false;
					});
				}
			}
		}
	};
});
